import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PagesContainer from 'components/settings/Pages/PagesContainer';
import UsersContainer from 'components/settings/Users/UsersContainer';
import GroupsContainer from 'components/settings/Groups/GroupsContainer';
import SiteLicense from 'components/settings/SiteLicense';
import QsServer from 'components/settings/QsServer';
import Settings from 'components/Pages/Settings';
import AuthAlert from 'components/settings/AuthAlert';
import DagContainer from 'components/settings/DynamicApplicationGeneration/DagContainer';
import ThemeSettings from 'components/settings/Appearance/ThemeSettings';
import ApiKey from 'components/settings/ApiKey';
import { qlikClient } from 'constants/environmental';
import SaaSQsServer from 'components/settings/SaaS/SaaSQsServer';
import config from 'coeus.config';

const SAAS = config.saas_client === qlikClient.SAAS;

const SettingsContainer = () => {
    const match = useRouteMatch();
    const basePath = match.path;

    const qServerComponent = SAAS ? SaaSQsServer : QsServer;

    return (
        <Switch>
            <Route
                path={`${basePath}/site-licence`}
                exact
                component={SiteLicense}
            />
            <Route
                path={`${basePath}/qsserver`}
                exact
                component={qServerComponent}
            />
            <Route
                path={`${basePath}/auth-alert`}
                exact
                component={AuthAlert}
            />
            <Route path={`${basePath}/theme`} exact component={ThemeSettings} />
            <Route path={`${basePath}/pages`} component={PagesContainer} />
            <Route path={`${basePath}/groups`} component={GroupsContainer} />
            <Route path={`${basePath}/users`} component={UsersContainer} />
            {config.feature.adag.enabled && (
                <Route path={`${basePath}/dag`} component={DagContainer} />
            )}
            <Route path={`${basePath}/api-key`} component={ApiKey} />
            <Route component={Settings} />
        </Switch>
    );
};

export default SettingsContainer;
